"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoArtworkIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** NoArtworkIcon */
var NoArtworkIcon = function NoArtworkIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "No artwork image" : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 28 28"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M8.84795 7.39814L14.073 1.55566L19.1548 7.39814H19.4573L23.789 3.06059L24.8889 4.16054L21.6557 7.39814H23.3334V21.3981H7.67469L4.18857 24.889L3.08862 23.7891L5.47629 21.3981H4.6667V7.39814H8.84795ZM9.22814 19.8426H21.7778V8.9537H20.1023L18.5488 10.5093H20.2223V18.287H10.7816L9.22814 19.8426ZM8.58319 18.287L7.02974 19.8426H6.22226V8.9537H17.9039L16.3504 10.5093H7.77781V18.287H8.58319ZM12.335 16.7315H18.6667V12.0648H16.9954L12.335 16.7315ZM14.797 12.0648L10.1366 16.7315H9.33337V12.0648H14.797ZM17.0931 7.39814L14.0567 3.90728L10.9348 7.39814H17.0931Z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
};

exports.NoArtworkIcon = NoArtworkIcon;
NoArtworkIcon.displayName = "NoArtworkIcon";
//# sourceMappingURL=NoArtworkIcon.js.map